module.exports = __webpack_public_path__ + "static/media/gml_logo.3cf817fe.svg";